/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roadmap_CopiedInputs */

const en_roadmap_copied = /** @type {(inputs: Roadmap_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ROADMAP.md copied`)
};

const de_roadmap_copied = /** @type {(inputs: Roadmap_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ROADMAP.md kopiert`)
};

/**
* | output |
* | --- |
* | "ROADMAP.md copied" |
*
* @param {Roadmap_CopiedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const roadmap_copied = /** @type {((inputs?: Roadmap_CopiedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roadmap_CopiedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_roadmap_copied(inputs)
	return en_roadmap_copied(inputs)
});